<template>
  <div class="grid grid-cols-2 gap-4">
    <ShareButton data-testid="share-facebook" :link="socialLinks?.facebook" display-text="Facebook" icon="social.facebook" />
    <ShareButton data-testid="share-pinterest" :link="socialLinks?.pinterest" display-text="Pinterest" icon="social.pinterest" />
    <ShareButton data-testid="share-twitter" :link="socialLinks?.twitter" display-text="X" icon="social.twitter" />
    <ShareButton data-testid="share-linkedin" :link="socialLinks?.linkedin" display-text="LinkedIn" icon="social.linkedin" />

    <hr class="col-span-2 border-slate-200 dark:border-zinc-700" />

    <ShareButton data-testid="share-gmail" :link="socialLinks?.gmail" display-text="Share via Gmail" icon="social.gmail" />
    <ShareButton data-testid="share-mail" :link="socialLinks?.mail" display-text="Share via Email" icon="social.mail" />
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';

import ShareButton from './Button.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const viewerItemStore = useViewerItemStore();

const { socialLinks } = storeToRefs(viewerItemStore);
</script>
